/* eslint-disable prettier/prettier */
import React from 'react';
import InputLabel from '../common/InputLabel';
import FormRow from './FormRow';
import NumberSelect from './NumberSelect';

const LabelSelectRow = ({
    selectSelectedOption = null,
    onSelectChange = () => { },
    selectValueName = '',
    title = '',
    selectStyles,
}) => (
    <FormRow
        style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '1em',
        }}
    >
        <InputLabel text={title} />
        <NumberSelect
            name={selectValueName}
            selectedOption={selectSelectedOption}
            handleChange={onSelectChange}
            selectStyles={selectStyles}
        />
    </FormRow>
);

export default LabelSelectRow;
